import {API} from './Api';
import ReactGA from "react-ga";
import unomiTracker from "unomi-analytics";
import {Setup} from "./Setup";


async function LogRequest(reqObj){
    let uid = "0"
    let cId = "0"
    let user = localStorage.getItem('user');
    if(user) {
        let parsed_user = JSON.parse(user);
        uid = parsed_user.uid;
        cId = parsed_user.phone
    }

    ReactGA.initialize('UA-175496552-1', {
        debug: false,
        titleCase: false,
        gaOptions: {
            userId: uid,
            clientId: cId
        }
    });

    unomiTracker.initialize({
        'Apache Unomi': {
            scope: 'PWA-APP',
            url: Setup.endpoint+"/tracker",
        }
    });


    const obj = {
        "source_uid": "",
        "user_uid": uid,
        "type":reqObj.type,
        "aggregation_key": "",
        "tags": "",
        "amount": "",
        "metadata": reqObj.meta,
        "request_meta": "",
        "source_updated": "",
        "source_created": new Date()
    }

    unomiTracker.track(reqObj.type,  {
        "user_uid": uid,
        "user_mobile": cId,
        "type":reqObj.type,
        "metadata": reqObj.meta,
        "created_date": new Date()
    });

    ReactGA.event({
        category: reqObj.type,
        action: reqObj.type+"_"+cId+"_("+reqObj.meta+")",
        label:"AB",
        value:"123"
    });

    //return  API.post(`/activities`,obj);
    return  "SEND_LOG";
}


export {LogRequest};
